export enum APP_INIT_STATES {
  INIT = 'init',
  DEFAULT = 'default',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}
